/*
	Define all API communication for a Transaction list and its individual items.
	These are consumed by the store module 'transaction.js'
*/

import API from '@/services/APIService';

export default {
  getInitialDecision(requestObj) {
	return API.call('/InitialDecision/retrieve', requestObj);
  },
};
